module.exports = __webpack_public_path__ + "img/rolling.4012cbbf.jpg";